import { setLocale } from "@/paraglide/runtime";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	beforeLoad: () => {
		setLocale("en", { reload: false });
		throw redirect({
			to: "/en" as any,
			replace: true,
		});
	},
});
